"use client";
import { j as i } from "./jsx-runtime-CJ-St4mQ.mjs";
import { createContext as r, useContext as m } from "react";
const t = r(
  void 0
), x = () => {
  const e = m(t);
  if (!e)
    throw new Error(
      "TimelineItem component can be used inside Timeline component"
    );
  return e;
}, u = ({
  variant: e,
  isConnected: n,
  children: o
}) => /* @__PURE__ */ i.jsx(t.Provider, { value: { variant: e, isConnected: n }, children: o });
export {
  u as TimelineProvider,
  x as useTimelineContext
};
